export default __webpack_public_path__ + "static/media/shutter.9f00809a.mp3";